var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM9.07 5.581C8.88488 5.581 8.70734 5.65454 8.57644 5.78544C8.44554 5.91634 8.372 6.09388 8.372 6.279V11.86C8.372 12.246 8.684 12.558 9.07 12.558H14.651C14.7448 12.5616 14.8384 12.5461 14.9261 12.5127C15.0138 12.4792 15.0939 12.4284 15.1615 12.3633C15.2292 12.2982 15.283 12.2201 15.3197 12.1337C15.3565 12.0473 15.3754 11.9544 15.3754 11.8605C15.3754 11.7666 15.3565 11.6737 15.3197 11.5873C15.283 11.5009 15.2292 11.4228 15.1615 11.3577C15.0939 11.2926 15.0138 11.2418 14.9261 11.2083C14.8384 11.1749 14.7448 11.1594 14.651 11.163H9.767V6.279C9.767 6.09405 9.6936 5.91666 9.56291 5.78579C9.43223 5.65492 9.25495 5.58126 9.07 5.581Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.a4eac0b25ae510a42658158290eccc83.svg";
export { ForwardRef as ReactComponent };